import { useEffect, useState } from "react";

export interface MicrophonePermissionState {
  hasMicrophoneAccess: boolean;
  isCheckingPermission: boolean;
}

export function useMicrophonePermission(): MicrophonePermissionState {
  const [hasMicrophoneAccess, setHasMicrophoneAccess] = useState(false);
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);

  useEffect(() => {
    const checkMicrophonePermission = async () => {
      try {
        setIsCheckingPermission(true);
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        setHasMicrophoneAccess(true);
        stream.getTracks().forEach(track => track.stop());
      } catch (error) {
        console.warn("Microphone access denied:", error);
        setHasMicrophoneAccess(false);
      } finally {
        setIsCheckingPermission(false);
      }
    };

    checkMicrophonePermission();
  }, []);

  return {
    hasMicrophoneAccess,
    isCheckingPermission,
  };
}
